"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var toServerOutputPath_exports = {};
__export(toServerOutputPath_exports, {
  toServerOutputPath: () => toServerOutputPath
});
module.exports = __toCommonJS(toServerOutputPath_exports);
var import_path = require("path");
function toServerOutputPath(input, outDir) {
  var normalized = input.replace(/\\/g, "/");
  var prefix = `${outDir}/server/`;
  if (normalized === `${outDir}/server` || normalized.startsWith(prefix)) {
    return normalized;
  }
  return import_path.posix.join(outDir, "server", normalized);
}
//# sourceMappingURL=toServerOutputPath.js.map
